import BaseModel from "./BaseModel";
import Booking from "./Booking";
import Hub from "./Hub";
import Subscription from "./Subscription";
import User from "./User";
import WhiteLabel from "./WhiteLabels";

/**
 * Account model with no relations
 */
class BaseAccount extends BaseModel {
  type: string;
  name: string;
  balanceCents: number;
  whiteLabelId: number;
  hasBikeShare: boolean;
  hasMabiCarShare: boolean;
  hasKintoShare: boolean;
  tags: string; /// comma separated list
  authorizedDomains?: string;
  defaultAllowBookByInvoice: boolean;
  static __dates = [];
  static types = { PRIVATE: "private", COMPANY: "company", REAL_ESTATE: "real_estate" };
  constructor(data) {
    super(data, Account.__dates);
    this.type = data.type;
    this.name = data.name;
    this.balanceCents = data.balanceCents;
    this.whiteLabelId = data.whiteLabelId;
    this.hasBikeShare = data.hasBikeShare;
    this.hasMabiCarShare = data.hasMabiCarShare;
    this.hasKintoShare = data.hasKintoShare;
    this.tags = data.tags;
    this.authorizedDomains = data.authorizedDomains ?? "";
    this.defaultAllowBookByInvoice = data.defaultAllowBookByInvoice;
  }

  /** Get an emoji that represents the account type. */
  static typeEmoji(type: String): string {
    switch (type) {
      case 'private': return '🧑';
      case 'company': return '🏷️';
      case 'real_estate': return '🏠️';
    }
    return '';
  }


}
/**
 * Account model with all relations
 */
class Account extends BaseAccount {
  users?: User[];
  hubs?: Hub[];
  subscriptions?: Subscription[];
  bookings?: Booking[];
  whiteLabel?: WhiteLabel;
  constructor(data) {
    super(data);
    this.users = data.users?.map((user) => new User(user));
    this.hubs = data.hubs;
    this.subscriptions = data.subscriptions;
    this.bookings = data.bookings;
    this.whiteLabel = data.whiteLabel ? new WhiteLabel(data.whiteLabel) : null;
  }
}

/**
 * Account model for index queries
 */
export class AccountListRow extends BaseAccount {
  userCount: number;
  userRegisteredCount: number;
  userInvitedCount: number;
  hubs?: Hub[];
  bookingsExternalCount: number;
  whiteLabel?: WhiteLabel;
  constructor(data) {
    super(data);
    this.userCount = data.userCount;
    this.userRegisteredCount = data.userRegisteredCount;
    this.userInvitedCount = Math.max(0, (data.userCount ?? 0) - (data.userRegisteredCount ?? 0));
    this.hubs = data.hubs;
    this.bookingsExternalCount = data.bookingsExternalCount;
    this.whiteLabel = data.whiteLabel ? new WhiteLabel(data.whiteLabel) : null;
  }
}

export default Account;
